import { Component, OnInit } from '@angular/core';
import { TvLiveService } from '../tv-live.service';
import { SeoService } from 'app/seoservice/seoservice';

@Component({
  selector: 'app-tv-live-page',
  templateUrl: './tv-live-page.component.html',
  styleUrls: ['./tv-live-page.component.scss']
})
export class TvLivePageComponent implements OnInit {
  tvList = [];
  pageParams = {
    page: 1,
    size: 24,
  };
  isPending = false;
  bottomLine = false;
  flexPlaceholder = [0,1,2,3,4,5];
  constructor(
    private _tvLiveService: TvLiveService,
    private _titleService: SeoService,
  ) { }

  ngOnInit(): void {
    this._titleService.setTitle('电视直播');
    this.getTvList();
  }

  getTvList() {
    this.isPending = true;
    this._tvLiveService.getTvLiveList(this.pageParams).subscribe(res => {
      // console.log(res);
      if (!!res && res.code !== 401) {
        const list = res;
        this.tvList = this.tvList.concat(list);
        // console.log(this.tvList);
        this.isPending = false;
        if (res.length < this.pageParams.size) {
          this.bottomLine = true;
        } else {
          this.bottomLine = false;
        }
      }
    })
  }

  getMore() {
    if (this.isPending) {
      return;
    }
    if (this.bottomLine) {
      return;
    }
    this.pageParams.page += 1;
    this.isPending = true;
    setTimeout(() => {
      this.getTvList();
    }, 100);
  }

}
